
import { Product, ProductCategory } from "@/script/apps/shop/entity/ShopEntity";
import { DictUtil } from "@/script/core/Dict";
import { ElLoading, ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { ProductService } from "@/script/apps/shop/service/ProductService";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import { ProductCategoryService } from "@/script/apps/shop/service/ProductCategoryService";

@Options({})
export default class ProductList extends BaseList {
  private queryEntity: Product = {};

  private dataList: Product[] = [];

  private productCategoryList: ProductCategory[] = [];

  private productService = new ProductService();

 public initData(): ServiceContext {   
    const data = ServiceFactory.build(
      "biz_shop_product",
      "/shop/product",
      "/shop/product",
      this.productService
    );
    data.statesName = "product-state";
    return data;
  }

  public initQueryEntity() {
    const self = this;
    this.queryEntity = {
      code: "",
      name: "",
      state: undefined,
      categoryId: undefined,
    };
    return this.queryEntity;
  }

  
  protected initOptions() {
    super.initOptions();
    const productCategoryService = new ProductCategoryService();
    productCategoryService.loadProductCategorys((data: any) => {
      this.productCategoryList = data;
    });
  }

  public afterLoadList(data: any): void {
    const products: Product[] = data.list as Product[];   
    this.dataList = products;
  }

  private put() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要上架的商品！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "上架执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.productService.put(ids).then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("上架失败，失败原因：" + error.message);
      }
    );
  }

  private out() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要下架的商品！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "下架执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.productService.out(ids).then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("下架失败，失败原因：" + error.message);
      }
    );
  }
}
